import React, { useMemo } from "react";
import {
  useGlobalFilter,
  useTable,
  usePagination,
  useSortBy
} from 'react-table';
import {
  TiArrowUnsorted,
  TiArrowSortedUp,
  TiArrowSortedDown
} from 'react-icons/ti';
import { GlobalFilter } from "./GlobalFilter";

// helper to mask everything but the first N chars
const maskValue = (raw, visibleChars = 3) => {
  const s = String(raw);
  if (s === 'n/a' || s.length <= visibleChars) return s;
  return s.slice(0, visibleChars) + '•'.repeat(s.length - visibleChars);
};

const Table = (props) => {
  const { accountType = 'Trial', companies } = props;

  const handleNextPageClick = () => {
    nextPage();
  };

  const handlePrevPageClick = () => {
    previousPage();
  };
  
  const companiesData = useMemo(() => [...companies], [companies]);
  const companiesColumns = useMemo(
    () =>
      companies[0]
      ? Object.keys(companies[0]).filter(key => key !== 'checked' && key !== 'notes' && key !== 'id').map(key => {
            if (key === 'id') {
              return {
                Header: key,
                accessor: key,
                Cell: e => e.value + 1
              };
            }
          if (key === 'website') {
            return { Header: key, accessor: key, Cell: e => e.value === 'n/a' ? e.value : <a href={e.value} target="_blank">{e.value.split('/')[2].replace('www.', '')}</a> }
          }
          if (key === 'phone') {
            return { Header: key, accessor: key, Cell: e => e.value === 'n/a' ? e.value : <a href={`tel:${e.value}`}>{e.value}</a> }
          }
          if (key === 'seoAudit') {
            return { Header: key, accessor: key, Cell: e => e.value === 'n/a' ? e.value : <a href={e.value} target="_blank"><button className="seo-btn">Seo Audit</button></a> }
          }
          return { Header: key, accessor: key };
        })
        : [],
      [companies]
    );

  const tableInstance = useTable({
    columns: companiesColumns,
    data: companiesData,
    initialState: { pageSize: 20 }
  },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    getToggleHideAllColumnsProps,
    headerGroups,
    page,
    nextPage,
    canNextPage,
    previousPage,
    canPreviousPage,
    pageOptions,
    setPageSize,
    allColumns,
    preGlobalFilteredRows,
    setGlobalFilter,
    state,
    prepareRow } = tableInstance;

    const { pageIndex, pageSize } = state;

  return (
    <>
    {companies.length > 1 && <GlobalFilter
      preGlobalFilteredRows={preGlobalFilteredRows}
      setGlobalFilter={setGlobalFilter}
      globalFilter={state.globalFilter}
      companiesData={companiesData}
      allColumns={allColumns}
      latestSearchId={props.latestSearchId}
      navigate={props.navigate}
      getToggleHideAllColumnsProps={getToggleHideAllColumnsProps}
    />}
    <table {...getTableProps()}>
      <thead>
        {headerGroups.map(headerGroup => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map(column => (
              <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                {column.render('Header')}
                {column.isSorted ? (column.isSortedDesc ? <TiArrowSortedDown /> : <TiArrowSortedUp />) : <TiArrowUnsorted />}
              </th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()}>
        {page.map((row, idx) => {
          prepareRow(row)
          return (
            <tr {...row.getRowProps()}>
              {row.cells.map(cell => {
                  const colId = cell.column.id;
                  // mask all non-name columns for Trial users
                  if (accountType === 'Trial' && colId !== 'name') {
                    return (
                      <td {...cell.getCellProps()}>
                        {maskValue(cell.value)}
                      </td>
                    );
                  }
                  // otherwise render normally
                  return (
                <td {...cell.getCellProps()}>
                  {cell.render('Cell')}
                </td>
);
})}
            </tr>
        );
        })}
      </tbody>
    </table>
    {companies.length > 1 && <div className="pagination-controlls-container">
      <p className="page-count-text">Page <strong>{pageIndex + 1} of {pageOptions.length}</strong></p>
      <select value={pageSize} onChange={e => {setPageSize(Number(e.target.value))}}>
        {
          [20, 50, 100].map(pageSize => (
            <option key={pageSize} value={pageSize}>Show {pageSize}</option>
          ))
        }
      </select>
      <button onClick={handlePrevPageClick} disabled={!canPreviousPage}>previous</button>
      <button onClick={handleNextPageClick} disabled={!canNextPage}>next</button>
    </div>}
    </>
  );
}

export default Table;
